class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.activeElement = triggeredBy;

    const pbContainer = this.querySelector('.goal-progress--drawer');
    const fill = this.querySelector('.goal-progress__bar-fill');
    if (fill) fill.style.width = '0%';

    this.classList.add('active');

    requestAnimationFrame(() => {
      const overlay = document.getElementById('CartDrawer-Overlay');
      if (overlay) {
        overlay.style.opacity = '1';
        overlay.style.pointerEvents = 'auto';
      }

      requestAnimationFrame(() => {
        this.classList.add('animate');

        if (pbContainer && fill) {
          const applyFill = (total) => {
            const threshold = parseInt(pbContainer.dataset.threshold || '0');
            if (threshold > 0) {
              fill.style.width = Math.min((total / threshold) * 100, 100) + '%';
            }
          };

          fetch('/cart.js')
            .then((r) => r.json())
            .then((cart) => {
              pbContainer.dataset.total = cart.total_price;
              if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
                publish(PUB_SUB_EVENTS.cartUpdate, { source: 'drawer-open', cartData: cart });
              } else {
                applyFill(cart.total_price);
              }
            })
            .catch(() => {
              applyFill(parseInt(pbContainer.dataset.total || '0'));
            });
        }

        this.addEventListener(
          'transitionend',
          () => {
            const container = this.classList.contains('is-empty')
              ? this.querySelector('.drawer__inner-empty')
              : document.getElementById('CartDrawer');
            trapFocus(container, this.querySelector('.drawer__close'));
          },
          { once: true }
        );
      });
    });
    document.body.classList.add('overflow-hidden');
  }

  close() {
    // Overlay: ocultar com transição
    const overlay = document.getElementById('CartDrawer-Overlay');
    if (overlay) {
      overlay.style.opacity = '0';
      overlay.style.pointerEvents = 'none';
    }

    this.classList.remove('animate');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    this.addEventListener(
      'transitionend',
      () => this.classList.remove('active'),
      { once: true }
    );
  }
}

if (!customElements.get('cart-drawer')) {
  customElements.define('cart-drawer', CartDrawer);
}
